module.exports = __webpack_public_path__ + "img/lagoon.7b6275ab.png";